export const PageName = 'Performer Landing Page';